var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',{staticClass:"mfs-auto"},[_c('a',{staticClass:"mr-1",attrs:{"href":"https://www.dognet.sk/","target":"_blank"}},[_vm._v("Panel 2")]),_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear())+" Dognet.sk.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }